import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
Vue.use(Router);
const router = new Router({
    mode: 'history',
    routes,
    base: process.env.VUE_APP_CLOUD_BASE_URL,
});
export default router;
